import * as React from 'react';
import { Form } from 'formik';
import styled from 'styled-components';
import { Panel } from '@rtkwlf/ui';
import { InformationInputs } from './form/InformationInputs';
import { SettingsInputs } from './form/SettingsInputs';
import { FooterButtons } from '../../FooterButtons';
import { useBeforeUnloadConfirmation } from '../../hooks/useBeforeUnloadConfirmation';
import { RouterPrompt } from '../../../../widgets/RouterPrompt';

const Container = styled.div`
  display: flex;
  align-items: flex-start;
`;

const LeftPanel = styled(Panel)`
  flex-grow: 2;
  && {
    margin-left: 0;
    padding: 3rem;
  }
`;

const RightPanel = styled(Panel)`
  flex-grow: 1;
  && {
    margin-right: 0;
    padding: 3rem;
  }
  max-width: 470px;
`;

const PanelTitle = styled.h2`
  margin-bottom: 2rem;
`;

type Props = {
  showSaveAndAdd?: boolean;
  view?: string;
};

export const OnboardingContactForm: React.FunctionComponent<Props> = ({
  showSaveAndAdd = false,
  view,
}) => {
  useBeforeUnloadConfirmation();

  return (
    <Form>
      <RouterPrompt />
      <Container>
        <LeftPanel>
          <PanelTitle>Information</PanelTitle>
          <InformationInputs />

          <FooterButtons showSaveAndAdd={showSaveAndAdd} view={view} />
        </LeftPanel>

        <RightPanel>
          <PanelTitle>Settings</PanelTitle>
          <SettingsInputs />
        </RightPanel>
      </Container>
    </Form>
  );
};
